function renderCreateDevModeIntegrationArtifactImportsTemplate({
  adminImportAlias,
  exportName,
  stringify,
  stringifySerializedValue,
  stringifyText,
  loadExportName,
  join,
  dynamicImports,
  snippetValues,
  lifecycleHookValues
}: {
  adminImportAlias: string
  exportName: string
  stringify: string
  stringifySerializedValue: string
  stringifyText: string
  loadExportName: string
  join: string
  dynamicImports: string
  snippetValues: string
  lifecycleHookValues: string
}): string {
  return `import type {
  DevModeIntegration,
  DevModeIntegrationMetadata,
  DevModeLifecycleHookExample,
  DevModeSnippet
} from '${adminImportAlias}/components/shared/dev-mode/dev-mode-types'

export const ${exportName} = {
  schemaName: ${stringify},
  schemaLabel: ${stringifySerializedValue},
  schemaType: ${stringifyText}
} satisfies DevModeIntegrationMetadata

export async function ${loadExportName}(): Promise<DevModeIntegration> {
  const [${join}] = await Promise.all([
${dynamicImports}
  ])
  const snippets = [
${snippetValues}
  ] as DevModeSnippet[]
  const lifecycleHooks = [
${lifecycleHookValues}
  ] as DevModeLifecycleHookExample[]

  return {
    ...${exportName},
    schemaJson: JSON.stringify(schemaModule.default, null, 2),
    snippets,
    lifecycleHooks
  }
}
`
}

function renderCreateDevModeIntegrationArtifactClientModuleTemplate({
  adminImportAlias,
  exportName,
  loadExportName,
  buttonExportName
}: {
  adminImportAlias: string
  exportName: string
  loadExportName: string
  buttonExportName: string
}): string {
  return `'use client'

import type { Setting } from '${adminImportAlias}/actions/settings'
import { DevModeIntegrateButton } from '${adminImportAlias}/components/shared/dev-mode-integrate'
import { ${exportName}, ${loadExportName} } from './integration'

interface ${buttonExportName}Props {
  initialSettings?: Setting | null
}

export function ${buttonExportName}({ initialSettings }: ${buttonExportName}Props) {
  return (
    <DevModeIntegrateButton
      integration={${exportName}}
      loadIntegration={${loadExportName}}
      initialSettings={initialSettings}
    />
  )
}
`
}

export function renderCreateDevModeIntegrationArtifactRenderer(
  request:
    | {
        kind: 'renderCreateDevModeIntegrationArtifactImportsTemplate'
        props: {
          adminImportAlias: string
          exportName: string
          stringify: string
          stringifySerializedValue: string
          stringifyText: string
          loadExportName: string
          join: string
          dynamicImports: string
          snippetValues: string
          lifecycleHookValues: string
        }
      }
    | {
        kind: 'renderCreateDevModeIntegrationArtifactClientModuleTemplate'
        props: {
          adminImportAlias: string
          exportName: string
          loadExportName: string
          buttonExportName: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderCreateDevModeIntegrationArtifactImportsTemplate':
      return renderCreateDevModeIntegrationArtifactImportsTemplate(request.props)
    case 'renderCreateDevModeIntegrationArtifactClientModuleTemplate':
      return renderCreateDevModeIntegrationArtifactClientModuleTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
